import { Offer } from '../types/vehicleOffer';
import { SerializedIncomingEmail } from './email-service';

/**
 * DTO for offer manual creation/review - contains only user-editable fields
 * Used for sending offers to frontend for review and receiving back for creation
 */
export type OfferReview = Pick<Offer, 'contactPerson' | 'freightDescription' | 'lengthM' | 'weightT' | 'loadingPlaces' | 'fePrice' | 'vehicleProperties' | 'publicRemark' | 'paymentDueWithinDays' | 'additionalInformation' | 'distanceKms'>;

export const enum MailOfferReviewStatus {
    PENDING = 0, // Not yet analyzed
    EMPTY = 1, // Analyzed, no offers found
    DETECTED = 2, // Quick scan detected offers in email body, full extraction pending
    REVIEW = 3, // Analyzed, offers found, awaiting user review
    CREATED = 4, // Offers successfully reviewed and created in the system
}

export interface MailOfferReview {
    id?: number;
    updatedOn?: Date;
    tenant_id: number;
    messageId: string; // IMAP/SMTP messageId header value uniquely identifying the source email
    status: MailOfferReviewStatus;
    offerReviews: OfferReview[]; // The extracted and geocoded OfferReview objects
    offerIds?: number[]; // Offers created from this email (populated when status = CREATED)
    contactEmail?: string; // Sender email
}

export type ScannedMail = SerializedIncomingEmail & { mailOfferReviewStatus?: MailOfferReviewStatus };
